import React from "react";
import {SetPassword} from "../components/SetPassword/SetPassword";

export const SetPasswordView = () => <SetPassword/>;